export function formatDate (dataString) {
    let date = new Date(dataString)
    let month = date.getMonth()+1
    let day = date.getDate()
    // if (month < 10) {
    //     month = '0' + month
    // }
    return month + '月' + day + '日'
}

//判断是否是微信浏览器的函数
export function isWeiXin () {
    //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
    var ua = window.navigator.userAgent.toLowerCase();
    //通过正则表达式匹配ua中是否含有MicroMessenger字符串
    if(ua.match(/MicroMessenger/i) == 'micromessenger'){
      return true;
    } else{
      return false;
    }
  }